import {useNavigate} from 'react-router-dom';

import {PackageIcon} from 'lucide-react';

import {Alert, AlertDescription} from '@/components/ui/alert.tsx';

import {Button} from '@/components/ui/button.tsx';

import {

	Empty,

	EmptyDescription,

	EmptyHeader,

	EmptyMedia,

	EmptyTitle,

} from '@/components/ui/empty.tsx';

import {Input} from '@/components/ui/input.tsx';

import {Label} from '@/components/ui/label.tsx';

import {Skeleton} from '@/components/ui/skeleton.tsx';

import {ProductPickerCard} from './product-picker-card';

import {useProductsPage} from './use-products-page';
import {pageContentClassName} from '../../../ui/pageContentClass';



function ProductPickerSkeleton() {

	return (

		<div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">

			{Array.from({length: 8}, (_, index) => (

				<div key={index} className="flex flex-col gap-2">

					<Skeleton className="aspect-square w-full"/>

					<Skeleton className="h-4 w-full"/>

					<Skeleton className="h-3 w-[66%]"/>

				</div>

			))}

		</div>

	);

}



export function ProductsPage() {

	const navigate = useNavigate();

	const state = useProductsPage();



	return (

		<div className={pageContentClassName}>

			<div className="mb-4 flex items-center justify-between gap-3">

				<h1 className="text-xl font-semibold tracking-tight">Товары</h1>

				<Button type="button" variant="ghost" size="sm" onClick={() => navigate('/ozon')}>

					Назад

				</Button>

			</div>



			<div className="flex flex-col gap-4">

				<div className="flex flex-col gap-1.5">

					<Label htmlFor="products-search">Поиск</Label>

					<Input

						id="products-search"

						value={state.query}

						onChange={(event) => state.setQuery(event.target.value)}

						placeholder="Артикул, название или SKU"

						autoComplete="off"

					/>

				</div>



				{state.error ? (

					<Alert variant="destructive">

						<AlertDescription>{state.error}</AlertDescription>

					</Alert>

				) : null}



				{state.loading ? <ProductPickerSkeleton/> : null}



				{!state.loading && !state.error && state.catalog?.length === 0 ? (

					<Empty className="border border-dashed">

						<EmptyHeader>

							<EmptyMedia variant="icon">

								<PackageIcon/>

							</EmptyMedia>

							<EmptyTitle>Каталог пуст</EmptyTitle>

							<EmptyDescription>Нет товаров для отображения</EmptyDescription>

						</EmptyHeader>

					</Empty>

				) : null}



				{!state.loading && !state.error && state.catalog && state.catalog.length > 0 && state.filtered.length === 0 ? (

					<p className="text-center text-sm text-muted-foreground">Ничего не найдено</p>

				) : null}



				{!state.loading && !state.error && state.filtered.length > 0 ? (

					<div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">

						{state.filtered.map((item) => (

							<ProductPickerCard

								key={item.offerId}

								item={item}

								stock={state.stockByOfferId.get(item.offerId)}

								onSelect={() =>

									navigate(`/ozon/products/${encodeURIComponent(item.offerId)}`)

								}

							/>

						))}

					</div>

				) : null}

			</div>

		</div>

	);

}

